import React from 'react';
import { useSelector } from 'react-redux';

import { Size } from '../../../core/enums/Size';
import deliveryZoneColorMap from '../../../core/constants/deliveryZoneColorMap';
import { RootState } from '../../../core/state/state';
import { selectDeliveryZoneById } from '../../../core/state/delivery-zones/selectors';
import Badge from '../badge/Badge';
import { Color } from '../../../core/enums/Color';

interface Props {
  id: number;
  size?: Size.Small | Size.Medium | Size.Large;
  iconOnly?: boolean;
  labelSize?: Size.Small | Size.Medium | Size.Large | Size.ExtraSmall;
  heightAuto?: boolean;
  isBlocked?: boolean;
}

const DeliveryZoneBadge: React.FC<Props> = ({ id, size = Size.Medium, iconOnly, labelSize, heightAuto, isBlocked }) => {
  const deliveryZone = useSelector((state: RootState) => selectDeliveryZoneById(state, id));

  if (!deliveryZone) {
    return <></>;
  }

  return (
    <Badge
      color={isBlocked ? Color.MiddleGrey : deliveryZoneColorMap[deliveryZone.creationIndex]}
      icon={deliveryZone.creationIndex}
      label={iconOnly ? undefined : deliveryZone.name}
      size={size}
      labelSize={labelSize}
      heightAuto={heightAuto}
    />
  );
};

export default DeliveryZoneBadge;
